const fulfillmentCenterLocations = [
  { name: '', value: 'Unknown' },
  { name: 'Idaho Falls', value: 'IdahoFalls' },
  { name: 'Tempe', value: 'Arizona' },
  { name: 'Dallas', value: 'Texas' }
]

const shippingAddress = [
  { name: 'Mail To Street', value: 'MailToStreet' },
  { name: 'Mail To City', value: 'MailToCity' },
  { name: 'Mail To State', value: 'MailToState' }
]

// A list of international locations, used for address validation.
const internationalLocation = [
  // Countries
  { name: 'Canada', value: 'canada' },
  { name: 'China', value: 'china' },
  { name: 'India', value: 'india' },
  { name: 'Mexico', value: 'mexico' },

  // States & Provinces
  { name: 'Antioquia', value: 'antioquia' }, // Department in Colombia
  { name: 'British Columbia', value: 'british columbia' }, // Province in Canada
  { name: 'ON', value: 'on' }, // Province in Canada

  // Cities
  { name: 'Beijing', value: 'beijing' }, // China
  { name: 'Hangzhou', value: 'hangzhou' }, // China
  { name: 'Shanghai', value: 'shanghai' }, // China
  { name: 'Shenzhen', value: 'shenzhen' }, // China
  { name: 'Dubai', value: 'dubai' }, // UAE
  { name: 'Ciudad de Mexico', value: 'ciudad de mexico' }, // Mexico
  { name: 'Mexico City', value: 'mexico city' }, // Mexico
  { name: 'Buenos Aires', value: 'buenos aires' }, // Argentina
  { name: 'Santiago', value: 'santiago' }, // Chile
  { name: 'Bogota', value: 'bogota' }, // Colombia
  { name: 'Vancouver', value: 'vancouver' } // Canada
]

const countryLocation = [
  { name: 'US', value: 'us' },
  { name: 'USA', value: 'usa' },
  { name: 'United States', value: 'united states' },
  { name: 'United States of America', value: 'united states of america' }
]

// List of US states and territories
const usStates = [
  'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC',
  'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY',
  'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE',
  'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK',
  'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT',
  'VA', 'VI', 'WA', 'WV', 'WI', 'WY'
]

// List of military zones
const militaryZones = [
  'APO', // Army Post Office
  'FPO', // Fleet Post Office
  'DPO' // Diplomatic Post Office
]

// Client codes that should be treated as domestic (bypass international validation)
const domesticClientCodes = ['C867', 'C862']

export { fulfillmentCenterLocations, shippingAddress, internationalLocation, countryLocation, usStates, militaryZones, domesticClientCodes }
